import type { RefObject } from 'react'
import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import { getFullOffsetOfElement } from 'shared/utils/get-full-offset-of-element'
import { isFirefox } from 'shared/utils/is-firefox'

// NOTE: fix scrolling to anchors for iframes
export const useFixAnchorsForIframe = (
  iframeRef: RefObject<HTMLIFrameElement>,
  rerun?: unknown,
): void => {
  useEffect(() => {
    if (!iframeRef.current) return

    const setHash = (): void => {
      try {
        if (
          globalThis.location.hash &&
          iframeRef.current?.contentDocument?.body.querySelector(globalThis.location.hash)
        ) {
          window.scrollTo(
            0,
            getFullOffsetOfElement(
              iframeRef.current.contentDocument.body.querySelector(
                globalThis.location.hash,
              ) as HTMLElement,
            ) + getFullOffsetOfElement(iframeRef.current),
          )
        }
      } catch (error) {
        Sentry.captureMessage('Failed to scroll to anchor', {
          level: 'error',
          extra: {
            hash: globalThis.location.hash,
            error,
          },
        })
      }
    }

    const setHashWithTimeout = (): void => {
      setHash()
      // NOTE: (for Firefox) clear hash to have ability to scroll to the same hash, if the same hash is already selected
      if (isFirefox()) {
        setTimeout(() => {
          // @ts-ignore
          globalThis.location.hash = null
        }, 1000)
      }
    }

    setHash()

    globalThis.addEventListener('hashchange', setHashWithTimeout)
    globalThis.addEventListener('popstate', setHashWithTimeout)

    return (): void => {
      globalThis.removeEventListener('hashchange', setHashWithTimeout)
      globalThis.removeEventListener('popstate', setHashWithTimeout)
    }
  }, [rerun, iframeRef])
}
